import { z } from 'zod';
import { EventLogSchemas } from '../domain/event-logs';

/**
 * API contracts for event log endpoints
 * Following grouped API pattern established in the codebase
 */

/**
 * Request schemas for event log endpoints
 */
const EventLogRequestSchemas = {
  // Create event log request
  create: EventLogSchemas.create,

  // Update event log request
  update: EventLogSchemas.update,

  // List event logs query parameters
  list: z.object({
    userId: z.string().optional(),
    limit: z.coerce.number().min(1).max(100).default(20),
    offset: z.coerce.number().min(0).default(0),
    source: z.string().optional(),
  }),

  // Get single event log by ID
  getById: z.object({
    id: z.string(),
  }),
};

/**
 * Response schemas for event log endpoints
 */
const EventLogResponseSchemas = {
  // Single event log response
  single: EventLogSchemas.full,

  // List of event logs response
  list: z.object({
    eventLogs: z.array(EventLogSchemas.list),
    total: z.number().int().min(0),
    limit: z.number().int().min(1),
    offset: z.number().int().min(0),
  }),

  // Create event log success response
  created: EventLogSchemas.full,

  // Update event log success response
  updated: EventLogSchemas.full,
};

/**
 * Grouped API contracts for event log endpoints
 * Following the established pattern in the codebase
 */
export const EventLogsAPI = {
  // GET /event-logs - List event logs with filters
  list: {
    request: EventLogRequestSchemas.list,
    response: EventLogResponseSchemas.list,
  },

  // POST /event-logs - Create new event log
  create: {
    request: EventLogRequestSchemas.create,
    response: EventLogResponseSchemas.created,
  },

  // GET /event-logs/:id - Get specific event log
  getById: {
    request: EventLogRequestSchemas.getById,
    response: EventLogResponseSchemas.single,
  },

  // PUT /event-logs/:id - Update event log
  update: {
    request: EventLogRequestSchemas.update,
    response: EventLogResponseSchemas.updated,
  },
};

// Export individual schemas for flexibility
export { EventLogRequestSchemas, EventLogResponseSchemas };
